import React, { useState } from "react";
import styles from "./reactivationResetPopup.module.css";
import IMAGES from "../../assets/images/images";
import { resetPassword } from "../../api/userManagement/forgotPassword.service";
import { Loader } from "../loader/Loader";
import { isLockedOut, recordAttempt } from "../../utils/arrayUtils";

const ReactivationResetPopup = ({ promptMessage, onCancel, emailId }) => {
  const [showMessage, setShowMessage] = useState(null);
  const [loader, setLoader] = useState(false);
  const handleSubmit = () => {
    if (isLockedOut()) {
      setShowMessage("You have exceeded the maximum number of attempts. Please try again after some time.");
      return;
    }
    setLoader(true);
    resetPassword(emailId)
      .then((response) => {
        setShowMessage(response.message);
        setLoader(false);
        //update attempts
        recordAttempt();
      })
      .catch((error) => {
        setShowMessage(null);
        setLoader(false);
        //update attempts
        recordAttempt();
      });
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.closes}>
          {" "}
          <img className={styles.close} onClick={onCancel} src={IMAGES.close} />
        </div>
        <div className={styles.head}>Password Reset Required</div>
        <p className={styles.message}>{promptMessage}</p>
        <div className={styles.buttons}>
        <span className={ !loader&&`${styles.poplink}`} onClick={handleSubmit}>
        {loader ? <Loader/> :"Get password reset link"}
        </span>
        </div>
        {showMessage && <div className={styles.successMsg}>{showMessage}</div>}
      </div>
    </div>
  );
};

export default ReactivationResetPopup;
